/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var usePrevious = function usePrevious(value, initialValue) {
  var ref = (0, _react.useRef)(initialValue);
  (0, _react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
};
var _default = usePrevious;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/hooks/usePrevious.js
// module id = 61
// module chunks = 0